"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RectangleTransformScalingHandler_drawingTools, _RectangleTransformScalingHandler_scalingConfig, _RectangleTransformScalingHandler_pointsMapping;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleTransformScalingHandler = void 0;
const viewer_features_drawing_tools_1 = require("@shapediver/viewer.features.drawing-tools");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const gl_matrix_1 = require("gl-matrix");
const RectangleTransformPointsMapping_1 = require("./RectangleTransformPointsMapping");
class RectangleTransformScalingHandler {
    constructor(viewport, parentNode, localPoints, visibilityConfig, scalingConfig) {
        var _a, _b, _c, _d;
        _RectangleTransformScalingHandler_drawingTools.set(this, void 0);
        _RectangleTransformScalingHandler_scalingConfig.set(this, void 0);
        _RectangleTransformScalingHandler_pointsMapping.set(this, void 0);
        __classPrivateFieldSet(this, _RectangleTransformScalingHandler_scalingConfig, scalingConfig, "f");
        __classPrivateFieldSet(this, _RectangleTransformScalingHandler_pointsMapping, new RectangleTransformPointsMapping_1.RectangleTransformPointsMapping(visibilityConfig), "f");
        const vis = scalingConfig === null || scalingConfig === void 0 ? void 0 : scalingConfig.visualization;
        // XY-plane restriction in parent-local space (the parent node carries the
        // plane-to-world transform, so the DT operates entirely in plane-LS).
        const lsRestriction = {
            type: viewer_rendering_engine_intersection_restriction_engine_1.RESTRICTION_TYPE.PLANE,
            origin: gl_matrix_1.vec3.create(),
            vector_u: gl_matrix_1.vec3.fromValues(1, 0, 0),
            vector_v: gl_matrix_1.vec3.fromValues(0, 1, 0),
            createHelperObjects: false,
        };
        // If step is configured, add a grid snap restriction to the plane restriction
        if (scalingConfig === null || scalingConfig === void 0 ? void 0 : scalingConfig.step) {
            lsRestriction.gridSnapRestriction = {
                gridUnit: scalingConfig.step,
                enabled: true,
                enableVisualization: false,
                createHelperObjects: false,
            };
        }
        // All four corners in order: C0(DT0), C2(DT1), C4(DT2), C6(DT3).
        const dtLSPoints = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").dtToConceptual.map((ci) => {
            const p = localPoints[ci];
            return [p[0], p[1], p[2]];
        });
        // EdgeControls: each controls the midpoint of an edge and has a fixed direction.
        const controls = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").edgeControls.map(({ conceptualEdgeControlIndex, corner1CI, corner2CI }) => {
            const di1 = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[corner1CI];
            const di2 = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[corner2CI];
            // Direction perpendicular to the edge in plane-LS:
            //   U-edges (M1, M5, horizontal) → V-axis (0,1,0)
            //   V-edges (M3, M7, vertical)   → U-axis (1,0,0)
            const isUEdge = conceptualEdgeControlIndex % 4 === 1;
            const direction = isUEdge
                ? gl_matrix_1.vec3.fromValues(0, 1, 0)
                : gl_matrix_1.vec3.fromValues(1, 0, 0);
            return {
                type: "edge",
                point1: di1,
                point2: di2,
                direction,
            };
        });
        // Build weightedAdjacency: locked corners are excluded as both sources and
        // targets so that adjacency propagation never moves a locked corner.
        // C0(BL)→C6(TL):[1,0,0], C0→C2(BR):[0,1,0]
        // C2(BR)→C4(TR):[1,0,0], C2→C0(BL):[0,1,0]
        // C4(TR)→C2(BR):[1,0,0], C4→C6(TL):[0,1,0]
        // C6(TL)→C0(BL):[1,0,0], C6→C4(TR):[0,1,0]
        const cornerAdjDefs = [
            { ci: 0, sameU: 6, sameV: 2 },
            { ci: 2, sameU: 4, sameV: 0 },
            { ci: 4, sameU: 2, sameV: 6 },
            { ci: 6, sameU: 0, sameV: 4 },
        ];
        const lockedSet = new Set(__classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").lockedCornerConceptualIndices);
        const weightedAdjacency = dtLSPoints.map(() => []);
        for (const { ci, sameU, sameV } of cornerAdjDefs) {
            if (lockedSet.has(ci))
                continue;
            const di = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[ci];
            const diU = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[sameU];
            const diV = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[sameV];
            if (!lockedSet.has(sameU))
                weightedAdjacency[di].push({
                    to: diU,
                    weights: [1, 0, 0],
                    space: "local",
                });
            if (!lockedSet.has(sameV))
                weightedAdjacency[di].push({
                    to: diV,
                    weights: [0, 1, 0],
                    space: "local",
                });
        }
        __classPrivateFieldSet(this, _RectangleTransformScalingHandler_drawingTools, (0, viewer_features_drawing_tools_1.createDrawingTools)(viewport, {
            onUpdate: () => { },
            onCancel: () => { },
        }, {
            general: {
                enableInsertion: false,
                enableDeletion: false,
                enableSelection: false,
            },
            geometry: {
                mode: "lines",
                points: dtLSPoints,
                close: true,
                minPoints: dtLSPoints.length,
                maxPoints: dtLSPoints.length,
                weightedAdjacency,
                disabledPoints: __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").disabledDTIndices.length > 0
                    ? __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").disabledDTIndices
                    : undefined,
                constraints: RectangleTransformScalingHandler.buildSizeConstraints(scalingConfig),
            },
            controls,
            restrictions: { plane: lsRestriction },
            visualization: Object.assign(Object.assign({ distanceMultiplicationFactor: 1.2, distanceLabels: false, pointerPosition: false }, vis), { points: Object.assign({ size_0: 30, size_1: 35, size_2: 30, size_3: 35, color: "#0d44f0", size_6: 20, color_6: "#888888" }, vis === null || vis === void 0 ? void 0 : vis.points), lines: Object.assign({ color: "#0d44f0" }, vis === null || vis === void 0 ? void 0 : vis.lines), edgeControlVisualization: {
                    points: Object.assign({ size_0: 25, size_1: 30, size_2: 25, size_3: 30, color: "#0d44f0" }, ((_b = (_a = vis === null || vis === void 0 ? void 0 : vis.edgeControlVisualization) === null || _a === void 0 ? void 0 : _a.points) !== null && _b !== void 0 ? _b : vis === null || vis === void 0 ? void 0 : vis.points)),
                    lines: Object.assign({ color: "#0d44f0" }, ((_d = (_c = vis === null || vis === void 0 ? void 0 : vis.edgeControlVisualization) === null || _c === void 0 ? void 0 : _c.lines) !== null && _d !== void 0 ? _d : vis === null || vis === void 0 ? void 0 : vis.lines)),
                } }),
        }, undefined, parentNode), "f");
    }
    get drawingTools() {
        return __classPrivateFieldGet(this, _RectangleTransformScalingHandler_drawingTools, "f");
    }
    get pointsMapping() {
        return __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f");
    }
    close() {
        __classPrivateFieldGet(this, _RectangleTransformScalingHandler_drawingTools, "f").close();
    }
    recompute(localPoints, temporary) {
        this.flushRectPoints(localPoints, temporary);
    }
    /**
     * Read back the corner positions currently stored in the drawing tool (after
     * any constraints have been applied) and return a full 8-point conceptual
     * local-space array.  Call this after `recompute` during creation so that
     * `#localPoints` in RectangleTransform reflects the constrained state.
     */
    readbackConstrainedPoints() {
        const dtPoints = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_drawingTools, "f").pointsData;
        const fullPoints = new Array(8);
        for (let di = 0; di < __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").dtToConceptual.length; di++) {
            const ci = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").dtToConceptual[di];
            const p = dtPoints[di];
            fullPoints[ci] = gl_matrix_1.vec3.fromValues(p[0], p[1], p[2]);
        }
        // Recompute midpoints as averages of their adjacent corners.
        fullPoints[1] = gl_matrix_1.vec3.fromValues((fullPoints[0][0] + fullPoints[2][0]) / 2, (fullPoints[0][1] + fullPoints[2][1]) / 2, 0);
        fullPoints[3] = gl_matrix_1.vec3.fromValues((fullPoints[2][0] + fullPoints[4][0]) / 2, (fullPoints[2][1] + fullPoints[4][1]) / 2, 0);
        fullPoints[5] = gl_matrix_1.vec3.fromValues((fullPoints[4][0] + fullPoints[6][0]) / 2, (fullPoints[4][1] + fullPoints[6][1]) / 2, 0);
        fullPoints[7] = gl_matrix_1.vec3.fromValues((fullPoints[6][0] + fullPoints[0][0]) / 2, (fullPoints[6][1] + fullPoints[0][1]) / 2, 0);
        return fullPoints;
    }
    /**
     * Handle a corner drag.
     * The DT has already propagated the drag delta to the two adjacent corners
     * via weightedAdjacency (space: "local") and applied size constraints.
     * This method reads the DT-updated positions and applies uniform scaling
     * on top when configured.
     */
    cornerPointMoved(index, updatedDtPoints, localPoints) {
        var _a;
        // Read all 4 corner positions from the DT (adjacency + constraints
        // already applied by the drawing tools).
        let c0 = this.getCornerFromDT(0, updatedDtPoints, localPoints);
        let c2 = this.getCornerFromDT(2, updatedDtPoints, localPoints);
        let c4 = this.getCornerFromDT(4, updatedDtPoints, localPoints);
        let c6 = this.getCornerFromDT(6, updatedDtPoints, localPoints);
        if ((_a = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_scalingConfig, "f")) === null || _a === void 0 ? void 0 : _a.uniform) {
            const n = index / 2;
            const controlsLeft = n === 0 || n === 3;
            const controlsBottom = n < 2;
            const prev = localPoints[index];
            const moved = this.getCornerFromDT(index, updatedDtPoints, localPoints);
            const signX = controlsLeft ? -1 : 1;
            const signY = controlsBottom ? -1 : 1;
            const deltaX = signX * (moved[0] - prev[0]);
            const deltaY = signY * (moved[1] - prev[1]);
            const d = Math.abs(deltaX) < Math.abs(deltaY) ? deltaX : deltaY;
            const adjustedX = prev[0] + signX * d;
            const adjustedY = prev[1] + signY * d;
            if (controlsLeft) {
                c0 = gl_matrix_1.vec3.fromValues(adjustedX, c0[1], 0);
                c6 = gl_matrix_1.vec3.fromValues(adjustedX, c6[1], 0);
            }
            else {
                c2 = gl_matrix_1.vec3.fromValues(adjustedX, c2[1], 0);
                c4 = gl_matrix_1.vec3.fromValues(adjustedX, c4[1], 0);
            }
            if (controlsBottom) {
                c0 = gl_matrix_1.vec3.fromValues(c0[0], adjustedY, 0);
                c2 = gl_matrix_1.vec3.fromValues(c2[0], adjustedY, 0);
            }
            else {
                c4 = gl_matrix_1.vec3.fromValues(c4[0], adjustedY, 0);
                c6 = gl_matrix_1.vec3.fromValues(c6[0], adjustedY, 0);
            }
        }
        const result = RectangleTransformScalingHandler.buildFullPoints(c0, c2, c4, c6);
        return result;
    }
    /**
     * Flush all four corner points to the single drawing tool.
     * EdgeControl handles (midpoints) are automatically repositioned by the DT.
     */
    flushRectPoints(localPoints, temporary) {
        __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").flushRectPoints(localPoints, __classPrivateFieldGet(this, _RectangleTransformScalingHandler_drawingTools, "f"), temporary);
    }
    /**
     * Handle an EdgeControl (midpoint) drag.
     * The drawing tools have already moved the two corner points for the dragged
     * edge (with constraints applied). This method reads the DT-updated positions
     * and applies uniform scaling on top when configured.
     */
    controlMoved(controlIndex, updatedDtPoints, localPoints) {
        var _a;
        // Read all 4 corner positions from the DT (already moved by EdgeControl
        // + constrained by the drawing tools).
        let c0 = this.getCornerFromDT(0, updatedDtPoints, localPoints);
        let c2 = this.getCornerFromDT(2, updatedDtPoints, localPoints);
        let c4 = this.getCornerFromDT(4, updatedDtPoints, localPoints);
        let c6 = this.getCornerFromDT(6, updatedDtPoints, localPoints);
        if ((_a = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_scalingConfig, "f")) === null || _a === void 0 ? void 0 : _a.uniform) {
            const { conceptualEdgeControlIndex } = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").edgeControls[controlIndex];
            const isUEdge = conceptualEdgeControlIndex % 4 === 1;
            const origC0 = localPoints[0];
            const origC2 = localPoints[2];
            const origC4 = localPoints[4];
            const origC6 = localPoints[6];
            if (isUEdge) {
                // Height (Y) changed; expand width symmetrically about center X.
                const heightChange = c6[1] - c0[1] - (origC6[1] - origC0[1]);
                const halfWidthChange = heightChange / 2;
                const centerX = (origC0[0] + origC2[0]) / 2;
                const prevHalfWidth = (origC2[0] - origC0[0]) / 2;
                const newLeft = centerX - prevHalfWidth - halfWidthChange;
                const newRight = centerX + prevHalfWidth + halfWidthChange;
                c0 = gl_matrix_1.vec3.fromValues(newLeft, c0[1], 0);
                c2 = gl_matrix_1.vec3.fromValues(newRight, c2[1], 0);
                c4 = gl_matrix_1.vec3.fromValues(newRight, c4[1], 0);
                c6 = gl_matrix_1.vec3.fromValues(newLeft, c6[1], 0);
            }
            else {
                // Width (X) changed; expand height symmetrically about center Y.
                const widthChange = c2[0] - c0[0] - (origC2[0] - origC0[0]);
                const halfHeightChange = widthChange / 2;
                const centerY = (origC0[1] + origC6[1]) / 2;
                const prevHalfHeight = (origC6[1] - origC0[1]) / 2;
                const newBottom = centerY - prevHalfHeight - halfHeightChange;
                const newTop = centerY + prevHalfHeight + halfHeightChange;
                c0 = gl_matrix_1.vec3.fromValues(c0[0], newBottom, 0);
                c2 = gl_matrix_1.vec3.fromValues(c2[0], newBottom, 0);
                c4 = gl_matrix_1.vec3.fromValues(c4[0], newTop, 0);
                c6 = gl_matrix_1.vec3.fromValues(c6[0], newTop, 0);
            }
        }
        return RectangleTransformScalingHandler.buildFullPoints(c0, c2, c4, c6);
    }
    /**
     * Build the DT constraints.size object from uMin/uMax/vMin/vMax.
     * Maps undefined bounds to 0 (for min) or Infinity (for max) so a
     * one-sided constraint can still be expressed as a [number, number] tuple.
     */
    static buildSizeConstraints(cfg) {
        var _a, _b, _c, _d;
        const hasX = ((cfg === null || cfg === void 0 ? void 0 : cfg.uMin) !== undefined && (cfg === null || cfg === void 0 ? void 0 : cfg.uMin) !== null) ||
            ((cfg === null || cfg === void 0 ? void 0 : cfg.uMax) !== undefined && (cfg === null || cfg === void 0 ? void 0 : cfg.uMax) !== null);
        const hasY = ((cfg === null || cfg === void 0 ? void 0 : cfg.vMin) !== undefined && (cfg === null || cfg === void 0 ? void 0 : cfg.vMin) !== null) ||
            ((cfg === null || cfg === void 0 ? void 0 : cfg.vMax) !== undefined && (cfg === null || cfg === void 0 ? void 0 : cfg.vMax) !== null);
        if (!hasX && !hasY)
            return undefined;
        return {
            size: Object.assign(Object.assign({}, (hasX ? { x: [(_a = cfg.uMin) !== null && _a !== void 0 ? _a : 0, (_b = cfg.uMax) !== null && _b !== void 0 ? _b : Infinity] } : {})), (hasY ? { y: [(_c = cfg.vMin) !== null && _c !== void 0 ? _c : 0, (_d = cfg.vMax) !== null && _d !== void 0 ? _d : Infinity] } : {})),
        };
    }
    /**
     * Read a conceptual corner position from the DT's updated points array.
     * Falls back to localPoints when the corner has no DT representation
     * (e.g. locked/disabled).
     */
    getCornerFromDT(conceptualIndex, updatedDtPoints, localPoints) {
        const di = __classPrivateFieldGet(this, _RectangleTransformScalingHandler_pointsMapping, "f").conceptualToDT[conceptualIndex];
        if (di >= 0) {
            return gl_matrix_1.vec3.fromValues(updatedDtPoints[di][0], updatedDtPoints[di][1], 0);
        }
        return gl_matrix_1.vec3.clone(localPoints[conceptualIndex]);
    }
    /**
     * Build the full 8-point conceptual array (4 corners + 4 midpoints) from
     * corner positions in plane local space.
     */
    static buildFullPoints(c0, c2, c4, c6) {
        const pts = new Array(8);
        pts[0] = c0;
        pts[2] = c2;
        pts[4] = c4;
        pts[6] = c6;
        for (let i = 1; i < 8; i += 2) {
            pts[i] = gl_matrix_1.vec3.fromValues((pts[(i + 7) % 8][0] + pts[(i + 1) % 8][0]) / 2, (pts[(i + 7) % 8][1] + pts[(i + 1) % 8][1]) / 2, 0);
        }
        return pts;
    }
}
exports.RectangleTransformScalingHandler = RectangleTransformScalingHandler;
_RectangleTransformScalingHandler_drawingTools = new WeakMap(), _RectangleTransformScalingHandler_scalingConfig = new WeakMap(), _RectangleTransformScalingHandler_pointsMapping = new WeakMap();
//# sourceMappingURL=RectangleTransformScalingHandler.js.map